import { render, staticRenderFns } from "./ContractIndex.vue?vue&type=template&id=473980f1"
import script from "./ContractIndex.vue?vue&type=script&lang=js"
export * from "./ContractIndex.vue?vue&type=script&lang=js"
import style0 from "./ContractIndex.vue?vue&type=style&index=0&id=473980f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports